import type { IMegaMenuBase, IMegaMenuConfig, IMegaMenuContext, IMegaMenuFavorite } from "./definitions";
import { isAllowed, isLicenceAllowed } from '@@services/rightsservice';

export function buildMegaMenuConfig(props: IMegaMenuContext, config: IMegaMenuConfig, favorites: IMegaMenuFavorite[]) {
    const menus: IMegaMenuConfig = { 
        
        entries : []
    };

    config?.entries.forEach((e) => {
        if (isItemAllowed(props, e)) {
            const sections = [];
            e.sections?.forEach((s) => {
                const sectionKey = e.key + "." + s.key;
                if (isItemAllowed(props, s)) {
                    const blocs = [];
                    s.blocs?.forEach((b, idx) => {
                        const blocOwnKey = b.key || "bloc" + idx;
                        const blockey = sectionKey + "." + blocOwnKey;
                        if (isItemAllowed(props, b)){
                            const items = [];
                            b.items?.forEach((it) => {
                                const itemOwnKey = it.key || it.link || it.title;
                                const itemKey = blockey + (itemOwnKey ? "." + itemOwnKey : "");                                
                                const fav = favorites?.find && favorites?.find((f) => f.key === itemKey);
                                
                                if (isItemAllowed(props, it)) {
                                    items.push({
                                        ...it,
                                        key: itemKey,
                                        favorite: !!fav
                                    });
                                }
                            });

                            if (items.length > 0 || b.component) {
                                blocs.push({
                                    ...b,
                                    key: blockey,
                                    items: items
                                });
                            }
                        }
                    });
                    if (blocs.length > 0 || s.component) {
                        sections.push({
                            ...s,
                            key: sectionKey,
                            blocs: blocs
                        });
                    }
                }
            });

            if (sections.length > 0 || e.link || e.component || e.rootComponent) {
                menus.entries.push({
                    ...e,
                    sections: sections
                });
            }
        }
    });

    return menus;
}

export function isItemAllowed(props: IMegaMenuContext, m: IMegaMenuBase) {
    if (!isAllowed(props.rights, m)) {
        return false;
    }
    if (m.customerLicenceRightsProvider) {
        const licences = m.customerLicenceRightsProvider(props);
        if (licences?.length > 0) {
            const forceHides = licences.filter((r) => r.forceHide == true);
            if (forceHides.length > 0 && !isLicenceAllowed(props.rights, { customerLicenceRights: forceHides })) {
                return false;
            }
        }
    }
    if (m.customerLicenceRights) {
        const forceHides = m.customerLicenceRights.filter((r) => r.forceHide == true);
        if (forceHides.length > 0 && !isLicenceAllowed(props.rights, { customerLicenceRights: forceHides })) {
            return false;
        }
    }

    if (m.hideOnMobile && props.isMobile) {
        return false;
    }

    if (m.advancedModeOnly && !props.user.advancedMode) {
        return false;
    }

    if (props.event?.eventid && m.applicable && !m.applicable(props.event.eventdetail, props.event.eventdetail
        && props.event.eventdetail.configuration, props.rights)) {
        return false;
    } else if (props.community?.communityid && m.applicable && !m.applicable(props.community?.detail,
        props.community?.detail?.configuration, props.rights)) {
        return false;
    } else if (props.customer?.customerid && m.customerApplicable
        && !m.customerApplicable(props.customer?.detail, props.rights)) {
        return false;
    }

    return true;
}